module.exports = __webpack_public_path__ + "img/北京轨道深色背景.fb88376b.png";